import { Component, OnInit, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
//import * as AOS from 'aos';
import { LinkService } from '../../_services/langhfre.service';
import { LoadScriptService } from 'src/app/_services/load-script.service';
import { NavigationService } from 'src/app/_services/navigation.service';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-language-services-publishing-and-media',
  templateUrl: './language-services-publishing-and-media.component.html',
  styleUrls: ['./language-services-publishing-and-media.component.scss']
})
export class LanguageServicesPublishingAndMediaComponent implements OnInit {
  
  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private _renderer2: Renderer2, 
    @Inject(DOCUMENT) private _document: Document,
    public loadScript: LoadScriptService,
    public navigationService: NavigationService
  ) {
    
  }

  ngOnInit() {
    this.titleService.setTitle("Trinka Enterprise | Language Services, Publishing & Media");
    this.metaTagService.updateTag({ name: 'description', content: "Enable your teams to write consistently, publish faster, and boost customer experience. Reduce writing time and costs without compromising on clarity." });
    this.metaTagService.updateTag({ property: 'og:title', content: "Trinka Enterprise | Language Services, Publishing & Media" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Enable your teams to write consistently, publish faster, and boost customer experience. Reduce writing time and costs without compromising on clarity." });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/enterprise/language-services-publishing-and-media' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/enterprise/language-services-publishing-and-media.webp' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Trinka Enterprise | Language Services, Publishing & Media' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Enable your teams to write consistently, publish faster, and boost customer experience. Reduce writing time and costs without compromising on clarity." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/enterprise/language-services-publishing-and-media.webp' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/enterprise/language-services-publishing-and-media' });

    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
    {"@context":"https://schema.org/","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Trinka AI","item":"https://www.trinka.ai/"},{"@type":"ListItem","position":2,"name":"Enterprise","item":"https://www.trinka.ai/enterprise"},{"@type":"ListItem","position":3,"name":"Language Services Publishing and Media","item":"https://www.trinka.ai/enterprise/language-services-publishing-and-media"}]}
    `;

    this._renderer2.appendChild(this._document.head, script);
    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
  }
  
  globalSliderData: any[] = [
    { "imgSrc": "/assets/images/client_logos/alternet.png", "altText": "alternet" },
    { "imgSrc": "/assets/images/client_logos/HarperCollinsPublishers.png", "altText": "Harper Collins Publishers" },
    { "imgSrc": "/assets/images/client_logos/scholastic.png", "altText": "scholastic" },
    { "imgSrc": "/assets/images/client_logos/sanchini.png", "altText": "sanchini" },
    { "imgSrc": "/assets/images/client_logos/technica.png", "altText": "technica" },
    { "imgSrc": "/assets/images/client_logos/CapstoneWriting.png", "altText": "Capstone Writing" },
    { "imgSrc": "/assets/images/client_logos/evolution_editing.png", "altText": "evolution editing" }
  ];

}
